export default "__VITE_ASSET__DAtMggMu__"